<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-1">
          <v-card-title class="pt-6 pb-2 px-6">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Team Members"
              single-line
              hide-details
              outlined
              dense
              class="rounded-pill"
              style="max-width: 400px;"
            ></v-text-field>
          </v-card-title>
          
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="members"
              :server-items-length="totalMembers"
              :options.sync="options"
              hide-default-footer
              class="elevation-0 mt-4 text-center"
            >
              <template v-slot:item.employeeName="{ item }">
                <span class="font-weight-medium">{{ item.employeeName }}</span>
              </template>
            </v-data-table>
            
            <v-layout justify-center class="mt-4 mb-2" v-if="pages > 1">
              <v-pagination
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                :length="pages"
                :total-visible="7"
                v-model="options.page"
                color="#005f32"
              ></v-pagination>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TeamMembers',
  data() {
    return {
      search: '',
      searchTimeout: null,
      headers: [
        { text: 'Employee Name', value: 'employeeName', align: 'center', class: 'font-weight-bold black--text text-subtitle-1' },
        { text: 'Designation', value: 'designation', align: 'center', class: 'font-weight-bold black--text text-subtitle-1' }
      ],
      members: [],
      totalMembers: 0,
      options: {}
    };
  },
  computed: {
    pages() {
      const itemsPerPage = this.options.itemsPerPage && this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 10;
      return Math.ceil(this.totalMembers / itemsPerPage) || 1;
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchMembers();
      },
      deep: true
    },
    search() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        if (this.options.page !== 1) {
          this.options.page = 1;
        } else {
          this.fetchMembers();
        }
      }, 500);
    }
  },
  methods: {
    async fetchMembers() {
      try {
        const { page, itemsPerPage } = this.options;
        const limit = itemsPerPage === -1 ? (this.totalMembers || 1000) : (itemsPerPage || 10);
        
        const token = localStorage.getItem('token');
        const res = await axios.get(`/my-team/members?page=${page || 1}&limit=${limit}&search=${this.search || ''}`, {
          headers: { 'x-auth-token': token }
        });
        if (res.data && res.data.status) {
          this.members = res.data.data;
          this.totalMembers = res.data.total || 0;
        }
      } catch (e) {
        console.error("Error fetching members:", e);
      }
    }
  }
};
</script>
